module.exports = __webpack_public_path__ + "img/lifting.6541001f.png";